import { HttpResponse } from '@angular/common/http';

/**
 * Reads async job id from a 202 Accepted response body (supports `id` and `async_job_id`).
 */
export function peekAsyncJobIdFromResponse(resp: HttpResponse<unknown>): string | null {
    if (resp.status !== 202) {
        return null;
    }
    const body = resp.body as Record<string, unknown> | null;
    if (!body) {
        return null;
    }
    const raw = body['async_job_id'] ?? body['id'];
    return raw != null && String(raw) !== '' ? String(raw) : null;
}
